import { render } from "./AddDepartmentView.vue?vue&type=template&id=03ac3354&scoped=true&ts=true"
import script from "./AddDepartmentView.vue?vue&type=script&lang=ts"
export * from "./AddDepartmentView.vue?vue&type=script&lang=ts"

import "./AddDepartmentView.vue?vue&type=style&index=0&id=03ac3354&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ac3354"]])

export default __exports__